import axios from "../axios";
import errorHandler from "../error-handler";

export const getPersonLists = (year) =>
    new Promise((resolve, reject) =>
        axios
            .get(`/person_lists`, {
                params: {
                    year
                }
            })
            .then((response) => resolve(response.data))
            .catch((error) => reject(errorHandler(error)))
    );

export const createPersonList = (data) =>
    new Promise((resolve, reject) =>
        axios
            .post(`/person_lists`, data)
            .then((response) => resolve(response.data))
            .catch((error) => reject(errorHandler(error)))
    );

export const getPersonList = (listId) =>
    new Promise((resolve, reject) =>
        axios
            .get(`/person_lists/${listId}`)
            .then((response) => resolve(response.data))
            .catch((error) => reject(errorHandler(error)))
    );

export const updatePersonList = (listId, data) =>
    new Promise((resolve, reject) =>
        axios
            .put(`/person_lists/${listId}`, data)
            .then((response) => resolve(response.data))
            .catch((error) => reject(errorHandler(error)))
    );

export const copyPersonList = (listId, taxYear) =>
    new Promise((resolve, reject) =>
        axios
            .post(`/person_lists/${listId}/copy`, {
                taxYear: taxYear
            })
            .then((response) => resolve(response.data))
            .catch((error) => reject(errorHandler(error)))
    );

export const deletePersonList = (listId) =>
    new Promise((resolve, reject) =>
        axios
            .delete(`/person_lists/${listId}`)
            .then((response) => resolve(response.data))
            .catch((error) => reject(errorHandler(error)))
    );
